module.exports = __webpack_public_path__ + "static/img/feature-bg.81d842e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-bg.png
// module id = Xhqm
// module chunks = 36